<template>
    <EmergencyContactFields
        :modelValue="form.emergency"
        :errors="emergencyErrors"
        @update:modelValue="emitEmergencyUpdate"
    />
</template>

<script>
import EmergencyContactFields from "@/components/modules/EmergencyContactFields.vue";

export default {
    name: "EmergencyContactSection",
    components: {
        EmergencyContactFields,
    },
    props: {
        form: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        emergencyErrors() {
            return {
                name: this.errors.emergencyName,
                phone: this.errors.emergencyPhone,
                relation: this.errors.emergencyRelation,
                relationOther: this.errors.emergencyRelationOther,
            };
        },
    },
    methods: {
        emitEmergencyUpdate(nextEmergency) {
            this.$emit("update:form", {
                ...this.form,
                emergency: nextEmergency,
            });
        },
    },
};
</script>
